export const defaultBarChartWidgetData = {
    labels : ["Loading...", "Loading...", "Loading...", "Loading...", "Loading..."],
    series: [[0, 0, 0, 0, 0]]
}